import React from "react";
import Name from "./Name";
import Table from "./Table";

const CompanyCustomers: React.FC = () => {
  return (
    <section>
      <Name />
      <Table />
    </section>
  );
};

export default CompanyCustomers;
